/**
 * Created by XuQiang on 2017/5/26.
 */
import request from '../utils/request';

export const onMessage = ({ locale, message, method }) => {
  const uri = `/notice/msg?lang=${locale}`;
  let body = '';
  if (method) {
    //删除
    body = JSON.stringify({
      ids: message
    });
  } else {
    body = JSON.stringify({
      msg: JSON.stringify(message)
    });
  }
  return request(uri, {
    method: method ? method : 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: body
  });
};

export const getMessageList = ({ pagination, locale, type, state }) => {
  if (Array.isArray(state)) {
    state = state.join(';');
  }
  const uri = `/notice/msg/getUserMessages?state=${state || ''}&type=${type ||
    ''}&page=${pagination.currentPage}&row=${
    pagination.pageSize
  }&lang=${locale}`;
  return request(uri);
};



// WEBPACK FOOTER //
// ./src/services/message.js